import { get } from './httpRequest';

// eslint-disable-next-line import/prefer-default-export
export const fetchPlatformInvoices = async () => {
  const response = await get('/platform-invoices');
  return response.data;
};
